import {Box, styled} from '@mui/material'

export const Content = styled(Box)(({theme}) => ({
  color: theme.palette.primary.contrastText,
  width: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
}))
